module.exports = __webpack_public_path__ + "img/02_4_4_3.bf6f7cf8.png";